/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, rest: NonNullable<unknown> }} Team_Summary_MemoryInputs */



/**
* | output |
* | --- |
* | "For {count} of them, Wundo already helps you prepare and keeps track of what you've discussed. {rest} to go, and you'll have everything at hand for every 1:1." |
*
* @param {Team_Summary_MemoryInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_summary_memory = /** @type {((inputs: Team_Summary_MemoryInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Summary_MemoryInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Bij ${i?.count} van hen helpt Wundo je al bij de voorbereiding en houdt het de rode draad van jullie gesprekken bij. Nog ${i?.rest} te gaan, en je hebt alles bij de hand voor elke 1:1.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Pour ${i?.count} d'entre eux, Wundo vous aide déjà à préparer et garde le fil de vos échanges. Encore ${i?.rest}, et vous avez tout sous la main pour chaque one-to-one.`)
	return /** @type {LocalizedString} */ (`For ${i?.count} of them, Wundo already helps you prepare and keeps track of what you've discussed. ${i?.rest} to go, and you'll have everything at hand for every 1:1.`)
});